<template>
  <div class='h100vh-140'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("System.createUserInfo")' :click="showCreateUser"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("System.change")' :click="showEditUser"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("System.delete")' :click="showDelUser"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="getUserList"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <input class="e-input" :placeholder='$t("Login.username")' @keyup.enter="getUserList" v-model="userKey" />
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <ejs-grid ref="grid" height='calc(100vh - 280px)' :allowPaging="true" :pageSettings="pageSettings">
        <e-columns>
          <e-column field="name" :headerText='$t("Login.username")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="group" :headerText='$t("System.fGroup")' width="150" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="tel" :headerText='$t("System.telephone")' width="130" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="mail" :headerText='$t("System.email")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="describe" :headerText='$t("System.description")' width="170" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getUserList"></ejs-pager>
    </div>
    <CustomDialog ref="createUserDialog" v-bind:element="createUserDialog.element" v-bind:styles="createUserDialog.styles">
      <template v-slot:dialog-content>
        <CreateUser ref="createUser" @childProps="getUserMessage"></CreateUser>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../common/CustomDialog";
import CreateUser from "../system/CreateUser";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "AddressUser",
  data() {
    return {
      pageSettings: { pageSize: 25 },
      pageCount: "4",
      userKey: "",
      userProps: {},
      pageNo: "1",
      createOrEdit: 0,
      createUserDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "createUser",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}`}
            },
            {
              click: this.confirmUser,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.createUserInfo')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      }
    };
  },
  components: {
    CustomDialog,
    CreateUser
  },
  methods: {
    getUserList() {
      const url = "/lte/ems/sysmanager/user/getData";
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      let params = {
        keyString: this.userKey,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.get(url, { params }).then(response => {
        this.$refs.grid.ej2Instances.dataSource = response.data.result;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          response.data.totalCount;
      });
    },
    showCreateUser() {
      this.createOrEdit = 0;
      this.createUserDialog.element.title = this.$t('System.createUserInfo');
      this.$refs.createUserDialog.show();
      this.$refs.createUser.bindValidate();
    },
    showEditUser() {
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.createOrEdit = 1;
      this.createUserDialog.element.title = this.$t('System.editUserInfo');
      this.$refs.createUser.init(record[0]);
      this.$refs.createUserDialog.show();
      this.$refs.createUser.bindValidate();
    },
    showDelUser() {
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.confirmDel'),
        btn1: {
          msg: this.$t('System.cancel'),
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delUser
        }
      });
    },
    dialogHide() {
      this.$refs.createUserDialog.clear();
      this.$refs.createUserDialog.close();
    },
    confirmUser() {
      if (!this.$refs.createUser.validate()) {
        return null;
      }
      if (this.createOrEdit === 0) {
        this.checkUserExist();
      } else {
        this.addUser("/lte/ems/sysmanager/user/updateUserWithEdit");
      }
    },
    checkUserExist() {
      const url = "/lte/ems/sysmanager/user/Verify";
      const params = {name:this.userProps.name};
      this.axios.get(url, { params }).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.userExists')});
        } else {
          this.addUser("/lte/ems/sysmanager/user/addUser");
        }
      });
    },
    addUser(dUrl) {
      const url = dUrl;
      const params = this.userProps;
      if (params.tel == '' && params.mail == '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.telephoneOrEmail')});
        return null;
      }
      this.$refs.createUserDialog.clear();
      this.$refs.createUserDialog.close();
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.getUserList();
      });
    },
    getUserMessage(data) {
      this.userProps = data;
    },
    getRecord() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    delUser() {
      const record = this.getRecord();
      const url = '/lte/ems/sysmanager/user/delete';
      var params = new URLSearchParams();
      params.append('name', record[0].name);
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.failure')});
        }
        this.getUserList();
      });
    }
  },
 /* mounted() {
    this.getUserList();
  }*/
};
</script>
